<template>
  <div
    style="padding:10px;"
    class="uk-position-relative">
    <div class="customer-div">
      <div v-if="customerScope" style="margin-top:10px;">
        {{ customerName }}
      </div>

      <el-popover
        v-else
        placement="bottom-start"
        trigger="hover"
      >
      <el-select  v-model="selectCustomers" multiple :placeholder="$t('public.table_scope')"
        slot="reference"
         @visible-change="handleChange">
        <el-option
          v-for="item in customerList"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <div class="hover-div">
        <div v-for="(item, index) in selectCustomersNameArr" :key="index" class="pd-5">
          <el-tag closable @close="handleClose(item)" type="info">{{item.name}}</el-tag>
        </div>
      </div>
      </el-popover>
    </div>

    <el-tabs type='card' v-model='tab' @tab-click="handleTabClick">
      <el-tab-pane :label="$t('public.device')" name='Device'></el-tab-pane>
      <el-tab-pane :label="$t('integration.abnormal')" name='Abnormal'></el-tab-pane>
       <el-tab-pane :label="$t('alarm.alarm')" name='Alarm'></el-tab-pane>
      <el-tab-pane :label="$t('integration.monitoring_point')" name='MonitoringPoint'></el-tab-pane>
    </el-tabs>
    <component :is='tab' ref='tab' :sceneIds="sceneIds"></component>
  </div>
</template>

<script>
import getRange from '@/utils/getRange.js';
import Device from './components/Device.vue'
import Abnormal from './components/Abnormal.vue'
import Alarm from './components/Alarm.vue'
import MonitoringPoint from './components/MonitoringPoint.vue'

export default {
  mixins: [ getRange ],
  components: {
    Device,
    Abnormal,
    Alarm,
    MonitoringPoint
  },
  data(){
    return {
      customerList: [], // 客户选择list
      selectCustomers: [],

      sceneIds: [],

      tab: 'Device',

    }
  },
  computed: {
    customerScope() { // 是否是客户角色
      return this.$store.getters.userInfo.scope.customerScope
    },
    isProxy(){ // 是否是代理角色
      return this.$store.getters.userInfo.scope.proxy
    },
    customerName(){
      return this.$store.getters.userInfo.scope.customerName
    },
    selectCustomersNameArr(){ // 用户多选框hover显示使用
      // 从客户列表中过滤已选择的selectCustomers，页面展示用到
      let arr = []
      this.selectCustomers.forEach(selId => {
        this.customerList.forEach(item => {
          if(selId === item.id){
            arr.push(item)
          }
        })
      })
      console.log('arr=', arr)
      return arr
    }
  },
  created(){
    console.log('customerScope=', this.customerScope)
    if(!this.customerScope && !this.isProxy){ // 平台角色
      this.getCustomer()
    }
    if(!this.customerScope && this.isProxy){ // 代理角色
      this.customerList = this.$store.getters.userInfo.switchScope
    }
    if(this.customerScope){
      this.sceneIds = [this.$store.getters.userInfo.scope.sceneId]
    }
  },
  methods: {
    getCustomer () {
     this.getCustomerList({
          type: 1,
          tab: 1
        }).then(({ result }) => {
        let list = []
        result.forEach((item, index) => {
          if(item.id !== '-1' && item.id !== '-2'){
            list.push(item)
          }
        })
        this.customerList = list

        // 默认一开始选择第一个客户组织
        this.selectCustomers = [this.customerList[0].id]
        this.handleChange()

      })
    },
    handleChange(e){
      // if(!e){
        console.log('选择的=', this.selectCustomers)
      this.sceneIds = this.selectCustomers
      console.log('选择的this.sceneIds=', this.sceneIds)
      this.$nextTick(() => {
        this.$refs.tab.getData()

      })
      // }

    },
    handleTabClick(){
      console.log('0000000000000000000000099999999999')
      this.$nextTick(() => {
        this.$refs.tab.getData()

      })
    },
    // hover-div中的客户tag删除
    handleClose(item){
      let index = this.selectCustomers.findIndex(_ => _ === item.id)
      this.selectCustomers.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__nav-wrap {
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-tabs__nav {
  float: none;
}
::v-deep .el-tabs__item {
  min-width: 140px;
  text-align: center;
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.customer-div {
  position: absolute;
  left: 20px;
  top: 15px;
  z-index: 999;
  ::v-deep.el-select__tags {
    flex-wrap: nowrap;
    overflow: hidden;
  }
}
.hover-div{
  min-width: 200px;
}

</style>
